const ARRAY: any = (Array as any)

export default class Utils {
    public static isDefined(obj: any): boolean {
        return obj != undefined
    }

    public static isNotBlank(str: string): boolean {
        return Utils.isDefined(str) && str.trim() !== ''
    }

    public static isNotEmpty(arr: Array<any>): boolean {
        return Utils.isDefined(arr) && arr.length > 0
    }

    public static asArray(arr: any): Array<any> {
        if (arr != undefined) {
            if (Utils.isDefined(ARRAY.from)) return ARRAY.from(arr)
            else {
                const newArr: Array<any> = []

                for (let i = 0; i < arr.length; i ++) {
                    newArr.push(arr[i])
                }

                return newArr
            }
        } else {
            console.debug('Array was undefined.')
            return []
        }
    }

    public static safeGetIncArr(obj: any, path: string) {
        let currentObj: any = obj

        for (let level of path.split('.')) {
            const regex = /(.*)\[([0-9]*)\]/g
            const match = regex.exec(level)

            if (!Utils.isDefined(currentObj)) {
                return undefined
            }

            if (Utils.isDefined(match)) {
                currentObj = Utils.isDefined(currentObj[match[1]]) ? currentObj[match[1]] : undefined

                if (Utils.isDefined(currentObj)) {
                    currentObj = Utils.isDefined(currentObj[parseInt(match[2], 10)]) ? currentObj[parseInt(match[2], 10)] : undefined
                }
            } else {
                currentObj = Utils.isDefined(currentObj[level]) ? currentObj[level] : undefined
            }
        }

        return currentObj
    }

    public static pluralise(amount: number, strSingle: string, strPlural: string): string {
        return amount !== 1 ? `${amount} ${strPlural}` : `${amount} ${strSingle}`
    }
}

export function getType(target: any, key: string): any {
    return Reflect.getMetadata('design:type', target, key)
}